import * as React from "react";
import { GafOktaManager } from "../../auth/gaf-okta-auth";
import { removeSessionBeforeUnload } from "../../utils/utils";
export class Callback extends React.Component {
    state = {
        authenticated: null,
        error: null,
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        GafOktaManager.handleAuthentication()
            .then((success) => {
                localStorage.removeItem("skipSessionClear");
                this.setState({ authenticated: true });
            })
            .catch((err) =>{
                this.setState({ authenticated: false, error: err.toString() });
            });
    }

    render() {
        if (this.state.authenticated === null) {
            return null;
        }
        if (this.state.authenticated) {
            removeSessionBeforeUnload();
            const requestURL = sessionStorage.getItem("requestURL");
            window.location.replace(requestURL);
            return null;
        } else {
            return <h1>this state authentication session is {this.state.error}</h1>;
        }
    }
}
